import { SidebarState } from "@/core/entities/sidebar/SidebarState";
import { ISidebarStateRepository } from "@/core/repositories/sidebarState";

export class GetSidebarStateUseCase {
  constructor(private readonly sidebarStateRepository: ISidebarStateRepository) {}

  async execute(): Promise<SidebarState> {
    return this.sidebarStateRepository.getSidebarState();
  }
}
